var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Portal", { attrs: { to: _vm.modalId } }, [
    _c(
      "div",
      { staticClass: "portal_model_container", class: _vm.portal_class },
      [
        _c("div", {
          staticClass:
            "fixed top-0 left-0 w-full h-full z-40 opacity-50 bg-black",
        }),
        _c(
          "div",
          {
            staticClass:
              "fixed top-0 left-0 w-full h-full z-40 py-10 overflow-auto flex overflow-y-scroll",
            on: { click: _vm.handleClickOutside },
          },
          [
            _c("div", {
              staticClass: "fixed z-10 top-0 bottom-0 left-0 right-0",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
            _c("div", {
              staticClass:
                "absolute z-20 top-0 bottom-0 left-0 right-0 overflow-y-hidden",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
            _c(
              "div",
              {
                staticClass:
                  "relative z-20 m-auto px-5 w-full portal_model_container_content_wrapper",
                class: _vm.maxWidth,
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative z-30 bg-white shadow-xl sm:w-full p-3 m-auto rounded-xl",
                    class: _vm.containerStyles,
                  },
                  [_vm._t("default")],
                  2
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }